import styled from 'styled-components';

export const StyledMessages = styled.div`
    
    overflow: auto;
    flex: auto;
    height: 80vh;
    

`